import { QueryClient } from '@tanstack/react-query'
import { UploadedDocument } from '@urbanx/agx-ui-components'
import { TaskCategoryTaskType } from '@urbanx/agx.activities.client'

export enum ConnectionState {
  NotConnected,
  Connecting,
  Connected,
  Reconnecting,
  Disconnected,
}

export enum NotificationType {
  PdfProcessedEvent = 'PdfProcessedEvent',
  ReadyForDocuSignEvent = 'ReadyForDocuSignEvent',
  CampaignUpdatedEvent = 'CampaignUpdatedEvent',
  RexListingCreatedEvent = 'RexListingCreatedEvent',
  TaskUpdatedNotification = 'TaskUpdatedNotification',
  TaskCreatedNotification = 'TaskCreatedNotification',
}

export interface PushNotification {
  registerEvent: (
    eventType: string,
    callback: (event: NotificationEvents, queryClient: QueryClient) => void,
    id?: (string | undefined)[]
  ) => void
  unregisterEvent: (
    eventType: string,
    eventCallback: (event: NotificationEvents) => void,
    id?: (string | undefined)[]
  ) => void
}

export interface PdfProcessedEvent {
  campaignId: string
  formId: string
  uploadedDocument: UploadedDocument
}

export interface CampaignUpdatedEvent {
  campaignId: string
  agencyId: string
}

export interface RexListingCreatedEvent {
  campaignId: string
  agencyId: string
  rexListingId: number
}

export interface TaskUpdatedNotification {
  campaignId: string
  taskType: TaskCategoryTaskType
  contractId?: string
  assignee?: string
  dueDate?: string
  inProgress?: boolean
  isCompleted?: boolean
  isLocked?: boolean
}

export interface TaskCreatedNotification {
  campaignId?: string
  taskType?: TaskCategoryTaskType
  contractId?: string
  assignee?: string
  dueDate?: string
  isLocked?: boolean
}

export type NotificationEvents = PdfProcessedEvent &
  CampaignUpdatedEvent &
  RexListingCreatedEvent &
  TaskUpdatedNotification &
  TaskCreatedNotification
